/* tslint:disable */
/* eslint-disable */
/* @relayHash 9c054a7835062e9095991f0f52cc63f1 */

import { ConcreteRequest } from "relay-runtime";
export type UploadFileMeta = {
    fileType: string;
    contentLength: number;
};
export type InterviewNotesModal_UploadRequestMutationVariables = {
    token: string;
    input: UploadFileMeta;
};
export type InterviewNotesModal_UploadRequestMutationResponse = {
    readonly interviewNotesUploadRequest: {
        readonly url: string;
        readonly successToken: string;
    } | null;
};
export type InterviewNotesModal_UploadRequestMutation = {
    readonly response: InterviewNotesModal_UploadRequestMutationResponse;
    readonly variables: InterviewNotesModal_UploadRequestMutationVariables;
};



/*
mutation InterviewNotesModal_UploadRequestMutation(
  $token: String!
  $input: UploadFileMeta!
) {
  interviewNotesUploadRequest(token: $token, input: $input) {
    url
    successToken
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "token",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "UploadFileMeta!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "interviewNotesUploadRequest",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                },
                {
                    "kind": "Variable",
                    "name": "token",
                    "variableName": "token"
                }
            ],
            "concreteType": "UploadFileResp",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "url",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "successToken",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "InterviewNotesModal_UploadRequestMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "InterviewNotesModal_UploadRequestMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "InterviewNotesModal_UploadRequestMutation",
            "id": null,
            "text": "mutation InterviewNotesModal_UploadRequestMutation(\n  $token: String!\n  $input: UploadFileMeta!\n) {\n  interviewNotesUploadRequest(token: $token, input: $input) {\n    url\n    successToken\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '1d3a0b0c8a1b733284858f981fb73c89';
export default node;
